/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsPresaInCaricoBancaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussi
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera la lista dei flussi
       */
      this.promiseRecuperaFlussi = function(stato, dataInizio, dataFine) {
        var qryParams = {
          stato: stato,
          dataInizio: dataInizio,
          dataFine: dataFine
        };

        return this.$http({
          method: 'GET',
          // url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.ORDINI,
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussoDettaglio
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera la il dettaglio del flusso
       */
      this.promiseRecuperaFlussoDettaglio = function(idOrdine) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.ORDINE.replace(
              '{idOrdine}',
              idOrdine
            )
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaStatoFlusso
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera gli stati dei flussi (aperto o chiuso)
       */
      this.promiseRecuperaStatoFlusso = function() {
        // return this.$http({
        //   method: 'PUT',
        //   url:
        //     CONSTANTS.REST_ROOT +
        //     CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO
        // });
        //manca servizio
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaStatoApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera gli stati degli apparati (presi in carico o danneggiati)
       */
      this.promiseRecuperaStatoApparato = function() {
        // return this.$http({
        //   method: 'PUT',
        //   url:
        //     CONSTANTS.REST_ROOT +
        //     CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO
        // });
        //manca servizio
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaStatoApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Aggiorna il stato del'apparato (preso in carico o danneggiato)
       */
      this.promiseAggiornaStatoApparato = function(idOrdine, apparato) {
        apparato.stato = JSON.parse(apparato.stato);

        var url = CONSTANTS.REST.APPROVVIGIONAMENTO.AGGIORNA_APPARATO.replace(
          '{idOrdine}',
          idOrdine
        );
        url = url.replace('{codApparato}', apparato.codice);

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + url,
          data: apparato
          // params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseChiudiFlusso
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Aggiorna il stato del'apparato (preso in carico o danneggiato)
       */
      this.promiseChiudiFlusso = function(flusso) {
        var url = CONSTANTS.REST.APPROVVIGIONAMENTO.CHIUDI_FLUSSO.replace(
          '{idOrdine}',
          flusso.id
        );

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + url,
          data: flusso
        });
      };

      /**
       * @ngdoc method
       * @name promisePrendeInCaricoBancaApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Prende in carico l'apparato (in stato preso in carico)
       */
      this.promisePrendeInCaricoBancaApparato = function(apparato) {
        apparato.stato = JSON.parse(apparato.stato);
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.APPARATO_PRESA_CARICO,
          data: apparato
        });
      };

      /**
       * @ngdoc method
       * @name salvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Esegue le chiamate per salvare le soglie.
       */
      this.salvaSoglie = function(soglie) {
        // self.spinner.showSpinner = true;

        self
          .promiseSalvaSoglie(soglie)
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                // self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.filiali = response.data.result;
              }
            },
            function(error) {
              if (self.messaggiFctr.processaResponse(error)) {
                // self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function() {
            // self.spinner.showSpinner = false;
          });
      };

      /**
       * @ngdoc method
       * @name promiseSalvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Effettua una chiamata http per aggiornare le soglie
       * @return {Promise} - Ritorna una promise contenente il dettaglio delle soglie
       */
      this.promiseSalvaSoglie = function(soglie) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE,
          data: soglie
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBancaSrvc.js
// module id = 13
// module chunks = 0